import React from "react"
import { cn } from "../utilities/helpers"

const Container = ({ className, stretch, children, ...props }) => {
  return !stretch ? (
    <div className={cn('max-w-screen-lg', 'mx-auto', className)}>
      <div className="px-[15px] md:px-[30px]">
        {children}
      </div>
    </div>
  ) : (
    <div className={cn(className)}>
      {children}
    </div>
  )
}

export default Container
